import React from 'react';
import 'react-lazy-load-image-component/src/effects/blur.css';

const Main = () => {
  return (
    <main className="main">
      <div className="page-title dark-background">
        <div className="heading">
          <div className="container">
            <div className="row d-flex justify-content-center text-center">
              <div className="col-lg-8">
                <h1>Apotik</h1>
                <p className="mb-0">
                  Apotik rumah sakit menyediakan obat-obatan lengkap dan
                  perlengkapan medis, dengan pelayanan cepat dan profesional
                  sesuai resep dokter.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section id="service-details" className="service-details section">
        <div className="container">
          <div className="row gy-4">
            <div className="col-lg-8" data-aos="fade-up" data-aos-delay="200">
              <img
                src="/img/fasilitas/APOTIK-1024.webp"
                srcSet="/img/fasilitas/APOTIK-256.webp 256w,
          /img/fasilitas/APOTIK-512.webp 512w,
          /img/fasilitas/APOTIK-1024.webp 1024w"
                sizes="(max-width: 768px) 100vw, 50vw"
                className="img-fluid services-img"
                alt="APOTIK"
                width="1024"
                height="512"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Main;
